import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CustomButton from 'components/CustomButton';
import { makeStyles } from '@mui/styles';
import { flowTrialActive } from 'utils';
import { useAuthUser } from 'features/auth/AuthUserContext';

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.common.white,
  },
}));

export default function Header() {
  const classes = useStyles();
  const { register } = useAuthUser();
  const textButton = flowTrialActive ? 'Get Started Now' : 'Start creating Now';

  return (
    <Box pt={1} pb={3.5}>
      <Container>
        <Typography component="h1" variant="h4" align="center" className={classes.title}>
          <b>
            Access powerful Mind the Graph features to make <br /> science figures, posters and
            infographics.
          </b>
        </Typography>

        <Box display="flex" justifyContent="center" mt={3} mb={4}>
          <CustomButton onClick={register}>{textButton}</CustomButton>
        </Box>
      </Container>
    </Box>
  );
}
